import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-workingholiday',
  imports: [],
  templateUrl: './workingholiday.component.html',
  styleUrl: './workingholiday.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkingholidayComponent {

}
